blue.ready('collapse', '.collapse', collapse => {
	const title = collapse.querySelector('.collapse-title')
	const content = collapse.querySelector('.collapse-content')

	title.addEventListener('click', e => {
		let height = content.offsetHeight
		let newHeight

		collapse.classList.toggle('is-active')
		newHeight = content.offsetHeight
		content.animate(
			[
				{
					height: `${height}px`
				},
				{
					height: `${newHeight}px`
				}
			],
			{
				duration: 300,
				easing: 'ease'
			}
		);
	})
})